import { Typography, Stack, Paper } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const EmptyListView = ({
  message = "No agents found.",
  suggestion = "Try adjusting your search filters or clearing your current selections.",
  onClearFilters = () => {
    console.log("Clear filters clicked!");
  },
  onBrowseAllAgents = () => {
    console.log("Browse all agents clicked!");
  },
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 3, sm: 4, md: 6 },
        m: "8px 2px",
        borderRadius: 3,
        textAlign: "center",
        height: "300px",
        bgcolor: "common.white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Stack spacing={2} alignItems="center">
        {/* Icon */}
        <SearchOffIcon
          sx={{
            fontSize: { xs: 60, md: 80 },
            color: "text.secondary",
            mb: 1,
          }}
        />

        {/* Main Message */}
        <Typography
          variant="h6"
          component="p"
          color="text.primary"
          sx={{ fontWeight: "medium" }}
        >
          {message}
        </Typography>

        {/* Suggestion Text */}
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          {suggestion}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default EmptyListView;
